import {

  UPDATE_SEARCHTDATA,
} from "./actionTypes";

export const updateSearch = (data) => ({
  type: UPDATE_SEARCHTDATA,
  payload: data,
});
